





















































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import { LikedTasksData } from "@/types";
import 'vue-i18n';

@Component
export default class Funnel extends Vue {
  @Prop({ type: Array, required: true }) items!: Array<LikedTasksData>;
  @Ref('toggleBtn') toggleBtn: any;


  isShownAllTasks = false;

    expandTasks() {
    this.isShownAllTasks = !this.isShownAllTasks;
    if(this.isShownAllTasks === true){
        this.$gtag.event('BI_expert_tasks')
       this.toggleBtn.innerHTML = this.$t("experts.btn_hide_all")

    }
    if (this.isShownAllTasks === false){
      this.toggleBtn.innerHTML = this.$t("experts.btn_show_all")
    }
  }


}
